import React, { useState, useRef, useEffect } from 'react';
import { Box, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { TABS } from '../../utils/constants';
import './AppTab.css';

export default function AppTab() {
    const [activeTab, setActiveTab] = useState(null);
    const location = window.location.pathname;
    const [indicatorStyle, setIndicatorStyle] = useState({});
    const navigate = useNavigate();
    const buttonRefs = useRef({});

    useEffect(() => {
        console.log(location);
        const currentTab = TABS.find(tab => location.startsWith(tab.link));
        setActiveTab(currentTab?.link ?? TABS[0]?.link);
    }, [location]);

    // Update indicator position when activeTab changes or window resizes
    useEffect(() => {
        const updateIndicator = () => {
            const activeButton = buttonRefs.current[activeTab];
            if (activeButton) {
                const rect = activeButton.getBoundingClientRect();
                const parentRect = activeButton.parentElement.getBoundingClientRect();
                setIndicatorStyle({
                    width: rect.width,
                    left: rect.left - parentRect.left
                });
            }
        };

        updateIndicator();
        window.addEventListener('resize', updateIndicator);
        return () => window.removeEventListener('resize', updateIndicator);
    }, [activeTab]);
  
    return (
        <Box className="app-tab-container">
            <Box className="app-tab-stack-wrapper">
                <Stack direction="row" spacing={1} className="app-tab-stack">
                    {TABS.map(tab => {
                        const Icon = tab.icon;
                        const isSelected = activeTab === tab.link;

                        return (
                            <Button
                                key={tab.link}
                                ref={el => (buttonRefs.current[tab.link] = el)}
                                onClick={() => {
                                    setActiveTab(tab.link);
                                    navigate(tab.link);
                                }}
                                sx={{ 'text-transform': 'none' }}
                                className={`app-tab-button ${isSelected ? 'selected' : ''}`}
                                color="inherit"   // <- ensures it uses inherited color instead of primary
                            >
                                <span className="app-tab-button-content">
                                    <span className="app-tab-icon-wrapper">
                                        {Icon ? <Icon fontSize="small" /> : null}
                                    </span>
                                    {tab.name}
                                </span>
                            </Button>
                        );
                    })}
                </Stack>

                {/* Indicator */}
                <Box className="app-tab-indicator" style={indicatorStyle} />
            </Box>
        </Box>
    );
}
